var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle205(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "214.910587973175 473.30410600668165 28.11041971921634 30.748216310183807",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M239.02,487.61c.04,4.02-1.11,7.2-3.6,9.81-2.74,2.87-6.64,3.49-9.96,1.38-3.93-2.49-6.35-6.07-6.54-10.85-.22-5.43,3.44-9.88,8.54-10.56,5.28-.7,10.26,2.95,11.34,8.34.15.75.18,1.52.22,1.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle205);
export default __webpack_public_path__ + "static/media/twinkle-2-05.c07efb9bc7f29f41a35b1fa06cabe741.svg";
export { ForwardRef as ReactComponent };